//#region package.json
var version = "1.6.2";
//#endregion
export { version };
